var grayBg = "/static/75fbb939774d611f.webp";

export { grayBg as default };
//# sourceMappingURL=bg.webp.js.map
